import NewUserOnboardingLayout from "@/shared/components/layout/NewUserOnboardingLayout";
import WebsiteUrl from "./WebsiteUrl";
import LLMSelection from "./LLMSelection";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useMainStore } from "@/stores";
import { USER_ROLES } from "@/shared/utils/constants";
import * as routeHelpers from "@/shared/utils/helperFunctions";
import Loader from "@/shared/components/ui/Loaders/Loader";

const NewOnboardingNewUser = () => {
  const user = useMainStore((s) => s.user);
  const userRole = user?.role;
  const appMode = useMainStore((s) => s.appMode ?? "user");
  const navigate = useNavigate();
  const isOrgAdminOnboarding = userRole === USER_ROLES.ORG_ADMIN;

  const [currentStep, setCurrentStep] = useState(1);
  const nonAdminExitStarted = useRef(false);

  /** Non–org-admins */
  useEffect(() => {
    if (!user?.id || userRole == null) return;
    if (isOrgAdminOnboarding) return;
    if (nonAdminExitStarted.current) return;
    nonAdminExitStarted.current = true;
    const { user: u, setUser } = useMainStore.getState();
    setUser({ ...u, isOnboarded: true, pricingPageCompleted: true });
    navigate(
      routeHelpers.getTargetRoute(useMainStore.getState().user, {
        appMode,
      }),
      { replace: true },
    );
  }, [user?.id, userRole, isOrgAdminOnboarding, appMode, navigate]);

  if (!user?.id || userRole == null) {
    return (
      <div className="flex max-w-[620px] w-full mx-auto h-full items-center justify-center">
        <Loader text="Loading..." />
      </div>
    );
  }

  if (!isOrgAdminOnboarding) {
    return (
      <div className="flex max-w-[620px] w-full mx-auto h-full items-center justify-center">
        <Loader text="Continuing..." />
      </div>
    );
  }

  const header = currentStep === 2 ? "back" : "logo";
  const onBack = currentStep === 2 ? () => setCurrentStep(1) : undefined;

  return (
    <NewUserOnboardingLayout header={header} onBack={onBack}>
      {currentStep === 1 ? (
        <LLMSelection setCurrentStep={setCurrentStep} />
      ) : (
        <WebsiteUrl />
      )}
    </NewUserOnboardingLayout>
  );
};

export default NewOnboardingNewUser;
